import React, { useEffect, useState } from "react";
import api from "../../utils/api";

interface Profile {
    userId?: string | null; // Optional, as per your condition
    staffId?: string | null;
    staffName?: string;
    staffEmail?: string | null;
    staffPhone?: string | null;
    staffPost?: string | null;
    staffJoiningDate?: string;
}

const AccountProfile: React.FC = () => {
// const profile = {
//     staffName: "John Doe",
//     staffEmail: "john.doe@example.com",
//     staffPhone: "+91 9876543210",
//     staffId: "EMP12345",
//     staffJoiningDate: "2022-01-15",
//     staffPost: "Software Engineer"
// };
const [profile, setProfile] = useState<Profile | null>(null);
const fetchProfile = async () => {
    try {
        const staffId = JSON.parse(localStorage.getItem("user")!).staffId;
        const response = await api.get(`/api/Auth/GetStaffDetailsByStaffId?staffId=${staffId}`);
        if (response.status === 200) {
            const data = await response.data;
            if(data.userId === "0" || data.userId === null) {
                setProfile({
                    userId: null,
                    staffName: "N/A",
                    staffEmail: "N/A",
                    staffPhone: "N/A",
                    staffId: "N/A",
                    staffJoiningDate: new Date().toISOString().split('T')[0],
                    staffPost: "N/A",
                });
            }else{
                setProfile({
                    userId: data.userId,
                    staffId: data.staffId,
                    staffName: data.staffName,
                    staffEmail: data.staffEmail,
                    staffPhone: data.staffPhone,
                    staffPost: data.staffPost, // Assuming staffPost is optional
                    staffJoiningDate: new Date(data.staffJoiningDate).toISOString().split('T')[0],
                });
            }
        }
    } catch (error) {
        // handle error if needed
    } 
};

useEffect(() => {
    fetchProfile();
}, []);

return (
    <div className='page-body'>
            <div className="d-flex justify-content-center align-items-center min-vh-80 py-4" style={{ backgroundColor: "#f5f6fa", minHeight: "80vh" }}>
                <div
                    className="card shadow border-0"
                    style={{
                        width: "100%",
                        maxWidth: 420,
                        padding: "2rem",
                        borderRadius: "1.5rem",
                        background: "linear-gradient(135deg, #e0e7ff 0%, #f5f6fa 100%)",
                    }}
                >
                    <div className="d-flex flex-column align-items-center mb-4">
                        <div
                            style={{
                                width: 90,
                                height: 90,
                                borderRadius: "50%",
                                background: "linear-gradient(135deg, #6366f1 60%, #818cf8 100%)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                marginBottom: 16,
                                boxShadow: "0 4px 16px rgba(99,102,241,0.15)",
                            }}
                        >
                            <span
                                style={{
                                    color: "#fff",
                                    fontSize: 36,
                                    fontWeight: 700,
                                    letterSpacing: 2,
                                }}
                            >
                                {profile && profile.staffName
                                    ? profile.staffName
                                            .split(" ")
                                            .filter(Boolean)
                                            .slice(0, 2)
                                            .map(word => word.charAt(0).toUpperCase())
                                            .join("")
                                    : "N/A"}
                            </span>
                        </div>
                        <h5 className="card-title fw-bold mb-1 text-center" style={{ color: "#3730a3" }}>
                            {profile ? profile?.staffName : "N/A"}
                        </h5>
                        <div className="text-muted mb-2 text-center" style={{ fontSize: 15 }}>
                            {profile ? profile?.staffPost : "N/A"}
                        </div>
                    </div>
                    <div className="mb-3">
                        <label className="form-label fw-semibold mb-1" style={{ color: "#6366f1" }}>
                            Email
                        </label>
                        <div className="form-control-plaintext text-break">{profile ? profile?.staffEmail : "N/A"}</div>
                    </div>
                    <div className="mb-3">
                        <label className="form-label fw-semibold mb-1" style={{ color: "#6366f1" }}>
                            Phone
                        </label>
                        <div className="form-control-plaintext">{profile ? profile?.staffPhone : "N/A"}</div>
                    </div>
                    <div className="mb-3">
                        <label className="form-label fw-semibold mb-1" style={{ color: "#6366f1" }}>
                            Staff ID
                        </label>
                        <div className="form-control-plaintext">{profile ? profile?.staffId : "N/A"}</div>
                    </div>
                    <div className="mb-0">
                        <label className="form-label fw-semibold mb-1" style={{ color: "#6366f1" }}>
                            Joining Date
                        </label>
                        <div className="form-control-plaintext">
                            {profile && profile.staffJoiningDate
                                ? new Date(profile.staffJoiningDate).toISOString().split('T')[0]
                                : "N/A"}
                        </div>
                    </div>
                </div>
            </div>
        </div>
);
}

export default AccountProfile;